export default __webpack_public_path__ + "static/media/img-0769-sweden-full-face.ba4022d2.png";